import { addState, flowMax, SimpleUnchangedProps } from 'ad-hok'
import { getContextHelpersFromInitialValues } from 'ad-hok-utils'

interface FormContext {
  formDisabled: boolean
  setFormDisabled: (disabled: boolean) => void
}

export const [addFormContextProvider, addFormContext] =
  getContextHelpersFromInitialValues<FormContext>({
    formDisabled: false,
    setFormDisabled: (_disabled: boolean) => {},
  })

export const addFormBoundary: SimpleUnchangedProps = flowMax(
  addState('formDisabled', 'setFormDisabled', false),
  addFormContextProvider
)
